"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PREFIX = 'ChatIcon';
var classes = {
    main: "".concat(PREFIX, "-main"),
};
var StyledSvgIcon = (0, styles_1.styled)(material_1.SvgIcon)((_a = {},
    _a["&.".concat(classes.main)] = {
        stroke: 'black',
    },
    _a));
var MapPinIcon = function (props) {
    return ((0, jsx_runtime_1.jsxs)(StyledSvgIcon, __assign({ fontSize: "small" }, props, { fill: "none", viewBox: "0 0 24 24", style: __assign({ color: 'transparent' }, props.style), className: (0, classnames_1.default)(classes.main, props.className) }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
exports.default = MapPinIcon;
